import { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest } from "src/async/apiUtils";
import { logoutRedirect } from "src/async/fetch";
import AuthLayout from "src/layouts/AuthLayout";
import { AuthContext } from "src/context/auth";
import { getNavigateLink } from "src/helpers/userHelper";
import { useWorkspaceSwitching } from "src/context/WorkspaceSwitchingContext";

const FreeAuthRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { setUser } = useContext(AuthContext);
  const { startSwitching } = useWorkspaceSwitching();

  const clickWorkspace = async () => {
    try {
      const { data: resData } = await apiRequest("GET", `/portal/users/workspaces/page`, {}, { returnErrorWithstatus: true });
      if (resData.status === 200) {
        const navigate_link = getNavigateLink(resData);
        navigate(navigate_link);
      } else {
        navigate("/permission-denied");
      }
    } catch (err) {
      navigate("/permission-denied");
    }
  };

  const redirectToWorkspace = async () => {
    try {
      const res = await apiRequest(
        "post",
        "/portal/users/self/details",
        {
          body: {
            token: localStorage.getItem("accessToken"),
            access_token: localStorage.getItem("accessToken"),
          },
        },
        { returnErrorWithstatus: true }
      );

      const resultData = res?.data;

      if (resultData?.status === "client_inactive" || resultData?.status === "inactive" || resultData?.status === 403) {
        navigate("/client-inactive");
        return;
      }

      if (resultData?.status !== 200) {
        logoutRedirect();
        return;
      }

      setUser(resultData.data);

      clickWorkspace();
    } catch (err) {
      if (
        err?.response?.data?.status === "client_inactive" ||
        err?.response?.data?.status === "inactive" ||
        err?.response?.status === 403 ||
        err?.data?.status === "client_inactive" ||
        err?.status === 403
      ) {
        navigate("/client-inactive");
        return;
      }
      logoutRedirect();
    }
  };

  useEffect(() => {
    if (localStorage.getItem("accessToken") && location.pathname !== "/sso-login" && !window.location.pathname.includes("/storage")) {
      if (location.pathname.includes("forgot-password") || location.pathname.includes("token")) {
        logoutRedirect(window.location.pathname);
      } else {
        redirectToWorkspace();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (localStorage.getItem("accessToken") && location.pathname !== "/sso-login") {
    if (!location.pathname.includes("forgot-password") && !location.pathname.includes("token")) {
      return startSwitching();
    }
  }

  return <AuthLayout />;
};

export default FreeAuthRoute;
